import { produce } from 'immer'
import baseReducer from '@utilities/base-reducer'
import * as Actions from './company-step-action'
import VerifyExistsEnum from '@constants/VerifyExistsEnum'

const initialState = {
  company: {
    cnpj: '',
    companyName: '',
    companyAlias: '',
    category: '',
    brand: null,
    physicalStore: false,
    virtualStore: false,
    virtualStoreAddress: '',
    optinRegulation: false,
  },
  cnpjExists: {
    type: VerifyExistsEnum.EmpresaNaoCadastrada,
  },
  categoryList: [],
  regulation: {
    version: '',
    uri: '',
  },
}

const onboardingReducer = baseReducer(initialState, {
  [Actions.SET_COMPANY_FIELD](state, { payload: { name, value } }) {
    return produce(state, draftState => {
      draftState.company = { ...state.company, [name]: value }
    })
  },
  [Actions.REQUEST_SET_EXISTS_COMPANY_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.cnpjExists = action.payload
    })
  },
  [Actions.REQUEST_GET_CATEGORIES_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.categoryList = action.payload
    })
  },
  [Actions.REQUEST_GET_CURRENT_ACCEPTANCE_TERMS_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.regulation = action.payload
    })
  },
})

export default onboardingReducer
